{
  "name": "next-cloudinary",
  "version": "6.17.5",
  "license": "MIT",
  "main": "./dist/index.js",
  "module": "./dist/index.mjs",
  "types": "./dist/index.d.ts",
  "source": "src/index.ts",
  "scripts": {
    "build": "tsup",
    "dev": "tsup --watch",
    "prepublishOnly": "cp ../README.md . && cp ../LICENSE . && pnpm build",
    "postpublish": "rm ./README.md && rm ./LICENSE",
    "test": "vitest run",
    "test:app": "NEXT_PUBLIC_CLOUDINARY_CLOUD_NAME=\"test\" pnpm build && cd tests/nextjs-app && npm install && npm run build",
    "test:watch": "vitest"
  },
  "dependencies": {
    "@cloudinary-util/types": "1.5.10",
    "@cloudinary-util/url-loader": "5.10.4",
    "@cloudinary-util/util": "4.0.0"
  },
  "devDependencies": {
    "@babel/core": "^7.25.2",
    "@babel/preset-env": "^7.25.3",
    "@tsconfig/recommended": "^1.0.7",
    "@types/node": "^22.0.2",
    "@types/react": "^18.3.3",
    "@types/react-dom": "^18.3.0",
    "dotenv": "^16.4.5",
    "mkdirp": "^3.0.1",
    "tsup": "^8.2.3",
    "typescript": "^5.5.4",
    "vitest": "^2.0.5"
  },
  "peerDependencies": {
    "next": "^12 || ^13 || ^14 || >=15.0.0-rc || ^15",
    "react": "^17 || ^18 || >=19.0.0-beta || ^19"
  }
}
